import React from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import LogoutIcon from '@material-ui/icons/PowerSettingsNew';

import {
  logoutPath,
  profilePath,
} from '../../constants/urls';

export const menuItems = translations => [
  {
    displayName: translations.profile,
    path: profilePath(),
    icon: <SettingsIcon />,
  },
  {
    displayName: translations.logout,
    path: logoutPath(),
    icon: <LogoutIcon />,
  },
]



// WEBPACK FOOTER //
// ./src/components/AppMenu/constants.js